// 导出页面为PDF格式
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
export default {
    install(Vue) {
        Vue.prototype.getPDF = function (dom, title, isDownload = true) {
            return new Promise((resolve, reject) => {
                    let c = document.querySelector(dom)
                    let imgs = Array.from(c.getElementsByTagName('img'))
                    imgs.forEach(async item => {
                        let src = item.getAttribute('src')
                        src = await toBase64(src)
                        item.setAttribute('src', src)
                    })
                html2Canvas(document.querySelector(dom), {
                    allowTaint: false,
                    // useCORS: true
                }).then(function (canvas) {
                    let contentWidth = canvas.width
                    let contentHeight = canvas.height
                    let pageHeight = contentWidth / 592.28 * 841.89
                    let leftHeight = contentHeight
                    let position = 0
                    let imgWidth = 595.28
                    let imgHeight = 592.28 / contentWidth * contentHeight
                    let pageData = canvas.toDataURL('image/jpeg')
                    let PDF = new JsPDF('', 'pt', 'a4')
                    // return
                    if (leftHeight < pageHeight) {
                        PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
                    } else {
                        while (leftHeight > 0) {
                            PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
                            leftHeight -= pageHeight
                            position -= 841.89
                            if (leftHeight > 0) {
                                PDF.addPage()
                            }
                        }
                    }
                    if (isDownload) {
                        PDF.save(title + '.pdf')
                    } else {
                        var pdfData = PDF.output('datauristring')
                        resolve(pdfData)
                    }
                })
            })
        }
    }
}
 const toBase64 = function (imgUrl) {
    return new Promise((resolve,reject) => {
        // 一定要设置为let，不然图片不显示
        const image = new Image();
        // 解决跨域问题
        image.setAttribute('crossOrigin', 'anonymous');
        const imageUrl = imgUrl + '?' + Math.random();
        image.src = imageUrl
        // image.onload为异步加载
        image.onload = () => {
            var canvas = document.createElement('canvas');
            canvas.width = image.width;
            canvas.height = image.height;
            var context = canvas.getContext('2d')
            context.fillStyle = "#fff"
            context.drawImage(image, 0, 0, image.width, image.height);
            var quality = 0.8;
            // 这里的dataurl就是base64类型  
            // 使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
            const dataurl = canvas.toDataURL('image/png', quality);
            resolve(dataurl)
        }
    })
}


// WEBPACK FOOTER //
// ./src/components/untils/getPDF.js